import React, { useEffect, useRef } from "react";
import { hideTitle } from 'hrg-fe-utils';
import Banner from "./components/Banner";
import Recommend from "./components/Recommend/recommend";
import { setMLog, getQuery} from "./env/fun";
import './index.scss';
hideTitle();
const App = () => {
  useEffect(() => {
    const source = getQuery('from', window.location.href);
    const sourceStr = source ? `_${source}` : '';
    setMLog(`2021magical_show${sourceStr}`);
  }, []);
  return (
    <div className="App">
      {/* 头图 */}
      <Banner />
      {/* 为您推荐 */}
      <Recommend />
      <div className="app-bottom">
        <img className="bottom-logo" alt="bottom-logo" src={require("./assets/img/bottom-logo.png")}></img>
      </div>
    </div>
  )
}

export default App;
